import Item from './item';
import SubMenu from './sub-menu';
import Menu from './menu';
import './styles/index.scss';
const ExportMenu = Menu;
ExportMenu.Item = Item;
ExportMenu.SubMenu = SubMenu;
ExportMenu.displayName = 'Menu';
export default ExportMenu;
